
slideshare_object.setup_activitylist_interaction = function() {
  var configs ={
    favs: {
      container: '#favsList',
      action_more: '.j-more-favs',
      meta: slideshare_object.activities.favorites,
      fill_template: function(item, activity){
        fillItem({
          meta: '.favoriteMeta',
          tags: '.j-tags',
          role: '.j-favoriter-role',
          org: '.j-favoriter-org',
          user_link: '.favoriter',
          username: '.j-username'
        }, item, activity);
      }
    },
  };

  function fillItem(fields, item, activity){
    $(fields.meta, item).html(activity.summary);
    if(fields.tag){
      $(fields.tag, item).html(activity.tags);
    }
    $(fields.role, item).text((activity.user_occupation === null ? '' : activity.user_occupation));
    $(fields.org, item).text(activity.user_organization);
    $(fields.user_link, item).each(function(index, link) {
      link.href = '/' + activity.login;
      link.title = activity.user_description;
      $('img', link).each(function(index, img) {
        img.src = activity.photo;
        img.alt = activity.login;
      });
      $(fields.username, link).text(activity.user_name);
    });
    item[0].className = activity.css_class;
  }
  // list of fav activity at bottom of page. not to be anchored to ss.svTools

  $.each(configs, function(key, config){
    var container = $(config.container);
    var template_node = null;
    $('li:first', container).each(function(index, ele) {
      template_node = ele.cloneNode(true);
    });
    if (config.meta && template_node) {
      if (config.meta.count < config.meta.total) {
        var action_more = $(config.action_more);
        if(key == "favs"){
          action_more.show();
        }
        action_more.jsclick(function() {
          var action_more_html = action_more.html();
          action_more.html(slideshare_object.loading_html);
          var current_length = $('li', container).length;
          var url = config.meta.url;
          var offset_param = 'offset=' + current_length;
          if(url.indexOf("?") >= 0){
            url += '&' + offset_param;
          } else {
            url += '?' + offset_param;
          }
          $.getJSON(url, function(json) {
            var temp_container = document.createDocumentFragment();
            $.each(json, function(index, activity) {
                var item = $(template_node.cloneNode(true));
                config.fill_template(item, activity);
                temp_container.appendChild(item[0]);
            });
            container.append(temp_container);
            if ($('li', container).length < config.meta.total) {
              action_more.html(action_more_html);
            }
            else {
              action_more.parent().remove();
            }
            $(".thumbnailGrid").trigger("adjustHeight");
          });
        });
      }
    }
  });
};
